/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CouponSubscriptionTypeRestrictionChange {
  changed?: boolean;
  couponId?: number;
  couponPriceChangeId?: number;
  couponSubscriptionTypeRestrictionChangeId?: number;
  dateCreated?: Date;
  subscriptionTypeId?: number;
  userId?: number;
}
